import React, {memo, useState} from "react";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import {toast} from "react-toastify";
import Button from "@mui/material/Button";
import {Head} from "../../../components";
import Api from "../../../utils/api";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {Paper} from "@mui/material";
import {useNavigate} from "react-router";

const ItemProductCreate = memo((props) => {


    const history = useNavigate();

    const initStat = {
        status: 1,
        title: '',
        link: '',
        products: [],
        form: "item_product_store",
        type: null,
        type_id: null,
        order: null,
    }

    const [form, setForm] = useState(initStat);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState(false);


    const handleChangeElement = (event) => {

        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };


    const handleSubmit = (event) => {

        event.preventDefault();

        setLoading(true);

        form['products'] = products;

        new Api().post('/products/itemProduct', form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setTimeout(() => {
                        history('/product/item')
                    }, 1000);
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }

    const handleChangeLoadList = (event) => {
        // new Api().fetchProducts({
        //     sort_field: event.target.value,
        //     sort_type: 'desc',
        //     page: 1,
        //     limit: 24
        // }).then((response) => {
        //     if (response !== "undefined") {
        //         let options = [];
        //         response.data.map((res) => {
        //             options.push({
        //                 id: res.id,
        //                 name: res.title
        //             });
        //         });
        //
        //         this.setState({options});
        //     }
        // });
    }



    return(
        <Container>
            <Head data={{ 'link': '/blog', 'title': 'ایجاد محتوا'}} />
            <Box mt={5}>
                <form onSubmit={handleSubmit}>
                    <Box mt={5}>
                        <Paper style={{ padding: '25px'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="عنوان"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.title}
                                        fullWidth
                                        name='title'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        select
                                        label="وضعیت"
                                        value={form.status}
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='status'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    >
                                        <MenuItem value={1}>فعال</MenuItem>
                                        <MenuItem value={0}>غیرفعال</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        style={{ textAlign: 'left', direction: 'ltr'}}
                                        label="لینک"
                                        value={form.link}
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='link'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    >
                                    </TextField>
                                </Grid>
                                {/*<Grid item xs={12}>*/}
                                {/*    <TextField*/}
                                {/*        select={true}*/}
                                {/*        label="پیشنهادی"*/}
                                {/*        variant="outlined"*/}
                                {/*        margin='dense'*/}
                                {/*        fullWidth*/}
                                {/*        name='link'*/}
                                {/*        // onChange={this.handleChangeLoadList.bind(this)}*/}
                                {/*        InputLabelProps={{*/}
                                {/*            shrink: true,*/}
                                {/*        }}*/}
                                {/*        helperText={'در صورت تمایل از لیست لود کنید'}*/}
                                {/*    >*/}
                                {/*        <MenuItem value={'id'}>جدیترین ها</MenuItem>*/}
                                {/*        <MenuItem value={'visitor'}>محبوبترینها</MenuItem>*/}
                                {/*        <MenuItem value={'sales_number'}>پرفروش ها</MenuItem>*/}
                                {/*    </TextField>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={12}>*/}
                                {/*    <div style={{ position: "relative"}}>*/}
                                {/*        <ProductAutoComplete onChange={(value) => {*/}
                                {/*            let products = [];*/}
                                {/*            value.forEach((value) => {*/}
                                {/*                products.push(value.id);*/}
                                {/*            });*/}
                                {/*            setProducts(products);*/}
                                {/*        }}/>*/}
                                {/*    </div>*/}
                                {/*</Grid>*/}
                            </Grid>
                        </Paper>
                    </Box>
                    <Box mt={5}>
                        <Button disabled={loading} variant='contained' color='primary' type="submit">ایجاد اطلاعات</Button>
                    </Box>
                </form>
            </Box>
        </Container>
    );
})



export default ItemProductCreate;